"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const clsx_1 = __importDefault(require("clsx"));
const CircledIcon_1 = __importDefault(require("@Components/CircledIcon"));
const ViewWorkSection = ({ icon, title, count, rightData, valid, children, }) => (react_1.default.createElement("div", { className: 'view-work-section' },
    react_1.default.createElement("div", { className: 'work-section-header' },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('validity-img', valid || 'invalid') }, valid !== undefined && (react_1.default.createElement("img", { src: valid ? common_1.ICONS.check : common_1.ICONS.error, alt: valid ? 'Valid' : 'Invalid' }))),
        react_1.default.createElement(CircledIcon_1.default, { icon: icon, alt: title }),
        react_1.default.createElement("h5", null,
            title,
            " ",
            (count || count === 0) && '(' + count + ')'),
        rightData && react_1.default.createElement("div", { className: 'right-data' }, rightData)),
    children));
exports.default = ViewWorkSection;
